/**
 * Funcion encargada de añadir el evento responsable de recoger el valor de la localizacion
 * del rinpool, la cual se encuetra en el atributo data-analytics-location del rinpool.
 */

export const getLocationCtaRingpoolRefactor = () => {
    document.querySelectorAll(".drp-phone").forEach(element => {
        element.addEventListener('mousedown', function(event) {
            const targetElement = event.target;
            let analyticsLocation = null;
            let analyticsElement = null;
            let anchorElement = null;

            // @ts-ignore
            if (targetElement.tagName.toLowerCase() === 'span') {
                // @ts-ignore
                anchorElement = targetElement.closest('a');
            // @ts-ignore
            } else if (targetElement.tagName.toLowerCase() === 'a') {
                anchorElement = targetElement;
            }

            if (anchorElement) {
                analyticsLocation = anchorElement.getAttribute("data-analytics-location");
                analyticsElement = anchorElement.getAttribute("data-analytics-element");
            }

            globalThis.location_cta = analyticsLocation !== null ? analyticsLocation : "Error: No se encontró data-analytics-location";
            globalThis.element_cta = analyticsElement !== null ? analyticsElement : "Error: No se encontró data-analytics-element";
        });
    });
};